import React from 'react';
import { Button, Form, FormGroup, FormInput } from 'shards-react';
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';

interface IdPasswordFormProps {
  email: string;
  password: string;
  isValid: boolean;
  isLoading: boolean;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSubmit: (event: React.SyntheticEvent<HTMLFormElement>) => void;
}

const IdPasswordForm = ({ email, password, isValid, isLoading, handleChange, handleSubmit }: IdPasswordFormProps): React.ReactElement => {
  const { t } = useTranslation();

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <label htmlFor="email">{t('user.email')}</label>
          <FormInput type="email" id="email" placeholder="Email" autoComplete="email" value={email} onChange={handleChange} />
        </FormGroup>
        <FormGroup>
          <label htmlFor="password">{t('user.password')}</label>
          <FormInput type="password" id="password" placeholder="Password" autoComplete="current-password" value={password} onChange={handleChange} />
        </FormGroup>
        <Button pill theme="accent" className="d-table mx-auto" type="submit" disabled={!isValid || isLoading}>
          {isLoading && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="mr-1" />}
          {t('login.login')}
        </Button>
      </Form>
    </>
  );
};

export default IdPasswordForm;
